import { styled } from "@mui/material";

export const Column = styled('div')(({ theme }) => ({
  flexGrow: 1,
  flexBasis: 300,
  display: "flex",
  flexDirection: "column"
}))

export const Header = styled('div')(({ theme }) => ({
  display: "flex",
  alignItems: "center"
}))